module.exports = __webpack_public_path__ + "static/kariera-blok-e81452f3868666dfd4425d06596e1b1e.jpeg";